import type { BibleBook, BibleTestament } from "@/lib/bible-types";
import { getLocalizedBookName } from "@/lib/bible-books-i18n";

/** Siglas em minúsculas, compatíveis com a ABíbliaDigital (gn, ex, job, jo…). */
export const BIBLE_BOOK_CATALOG: BibleBook[] = [
  { abbrev: "gn", name: "Gênesis", testament: "OT", bookOrder: 1, chapterCount: 50 },
  { abbrev: "ex", name: "Êxodo", testament: "OT", bookOrder: 2, chapterCount: 40 },
  { abbrev: "lv", name: "Levítico", testament: "OT", bookOrder: 3, chapterCount: 27 },
  { abbrev: "nm", name: "Números", testament: "OT", bookOrder: 4, chapterCount: 36 },
  { abbrev: "dt", name: "Deuteronômio", testament: "OT", bookOrder: 5, chapterCount: 34 },
  { abbrev: "js", name: "Josué", testament: "OT", bookOrder: 6, chapterCount: 24 },
  { abbrev: "jz", name: "Juízes", testament: "OT", bookOrder: 7, chapterCount: 21 },
  { abbrev: "rt", name: "Rute", testament: "OT", bookOrder: 8, chapterCount: 4 },
  { abbrev: "1sm", name: "1 Samuel", testament: "OT", bookOrder: 9, chapterCount: 31 },
  { abbrev: "2sm", name: "2 Samuel", testament: "OT", bookOrder: 10, chapterCount: 24 },
  { abbrev: "1rs", name: "1 Reis", testament: "OT", bookOrder: 11, chapterCount: 22 },
  { abbrev: "2rs", name: "2 Reis", testament: "OT", bookOrder: 12, chapterCount: 25 },
  { abbrev: "1cr", name: "1 Crônicas", testament: "OT", bookOrder: 13, chapterCount: 29 },
  { abbrev: "2cr", name: "2 Crônicas", testament: "OT", bookOrder: 14, chapterCount: 36 },
  { abbrev: "ed", name: "Esdras", testament: "OT", bookOrder: 15, chapterCount: 10 },
  { abbrev: "ne", name: "Neemias", testament: "OT", bookOrder: 16, chapterCount: 13 },
  { abbrev: "et", name: "Ester", testament: "OT", bookOrder: 17, chapterCount: 10 },
  { abbrev: "job", name: "Jó", testament: "OT", bookOrder: 18, chapterCount: 42 },
  { abbrev: "sl", name: "Salmos", testament: "OT", bookOrder: 19, chapterCount: 150 },
  { abbrev: "pv", name: "Provérbios", testament: "OT", bookOrder: 20, chapterCount: 31 },
  { abbrev: "ec", name: "Eclesiastes", testament: "OT", bookOrder: 21, chapterCount: 12 },
  { abbrev: "ct", name: "Cantares", testament: "OT", bookOrder: 22, chapterCount: 8 },
  { abbrev: "is", name: "Isaías", testament: "OT", bookOrder: 23, chapterCount: 66 },
  { abbrev: "jr", name: "Jeremias", testament: "OT", bookOrder: 24, chapterCount: 52 },
  { abbrev: "lm", name: "Lamentações", testament: "OT", bookOrder: 25, chapterCount: 5 },
  { abbrev: "ez", name: "Ezequiel", testament: "OT", bookOrder: 26, chapterCount: 48 },
  { abbrev: "dn", name: "Daniel", testament: "OT", bookOrder: 27, chapterCount: 12 },
  { abbrev: "os", name: "Oséias", testament: "OT", bookOrder: 28, chapterCount: 14 },
  { abbrev: "jl", name: "Joel", testament: "OT", bookOrder: 29, chapterCount: 3 },
  { abbrev: "am", name: "Amós", testament: "OT", bookOrder: 30, chapterCount: 9 },
  { abbrev: "ob", name: "Obadias", testament: "OT", bookOrder: 31, chapterCount: 1 },
  { abbrev: "jn", name: "Jonas", testament: "OT", bookOrder: 32, chapterCount: 4 },
  { abbrev: "mq", name: "Miquéias", testament: "OT", bookOrder: 33, chapterCount: 7 },
  { abbrev: "na", name: "Naum", testament: "OT", bookOrder: 34, chapterCount: 3 },
  { abbrev: "hc", name: "Habacuque", testament: "OT", bookOrder: 35, chapterCount: 3 },
  { abbrev: "sf", name: "Sofonias", testament: "OT", bookOrder: 36, chapterCount: 3 },
  { abbrev: "ag", name: "Ageu", testament: "OT", bookOrder: 37, chapterCount: 2 },
  { abbrev: "zc", name: "Zacarias", testament: "OT", bookOrder: 38, chapterCount: 14 },
  { abbrev: "ml", name: "Malaquias", testament: "OT", bookOrder: 39, chapterCount: 4 },
  { abbrev: "mt", name: "Mateus", testament: "NT", bookOrder: 40, chapterCount: 28 },
  { abbrev: "mc", name: "Marcos", testament: "NT", bookOrder: 41, chapterCount: 16 },
  { abbrev: "lc", name: "Lucas", testament: "NT", bookOrder: 42, chapterCount: 24 },
  { abbrev: "jo", name: "João", testament: "NT", bookOrder: 43, chapterCount: 21 },
  { abbrev: "at", name: "Atos", testament: "NT", bookOrder: 44, chapterCount: 28 },
  { abbrev: "rm", name: "Romanos", testament: "NT", bookOrder: 45, chapterCount: 16 },
  { abbrev: "1co", name: "1 Coríntios", testament: "NT", bookOrder: 46, chapterCount: 16 },
  { abbrev: "2co", name: "2 Coríntios", testament: "NT", bookOrder: 47, chapterCount: 13 },
  { abbrev: "gl", name: "Gálatas", testament: "NT", bookOrder: 48, chapterCount: 6 },
  { abbrev: "ef", name: "Efésios", testament: "NT", bookOrder: 49, chapterCount: 6 },
  { abbrev: "fp", name: "Filipenses", testament: "NT", bookOrder: 50, chapterCount: 4 },
  { abbrev: "cl", name: "Colossenses", testament: "NT", bookOrder: 51, chapterCount: 4 },
  { abbrev: "1ts", name: "1 Tessalonicenses", testament: "NT", bookOrder: 52, chapterCount: 5 },
  { abbrev: "2ts", name: "2 Tessalonicenses", testament: "NT", bookOrder: 53, chapterCount: 3 },
  { abbrev: "1tm", name: "1 Timóteo", testament: "NT", bookOrder: 54, chapterCount: 6 },
  { abbrev: "2tm", name: "2 Timóteo", testament: "NT", bookOrder: 55, chapterCount: 4 },
  { abbrev: "tt", name: "Tito", testament: "NT", bookOrder: 56, chapterCount: 3 },
  { abbrev: "fm", name: "Filemom", testament: "NT", bookOrder: 57, chapterCount: 1 },
  { abbrev: "hb", name: "Hebreus", testament: "NT", bookOrder: 58, chapterCount: 13 },
  { abbrev: "tg", name: "Tiago", testament: "NT", bookOrder: 59, chapterCount: 5 },
  { abbrev: "1pe", name: "1 Pedro", testament: "NT", bookOrder: 60, chapterCount: 5 },
  { abbrev: "2pe", name: "2 Pedro", testament: "NT", bookOrder: 61, chapterCount: 3 },
  { abbrev: "1jo", name: "1 João", testament: "NT", bookOrder: 62, chapterCount: 5 },
  { abbrev: "2jo", name: "2 João", testament: "NT", bookOrder: 63, chapterCount: 1 },
  { abbrev: "3jo", name: "3 João", testament: "NT", bookOrder: 64, chapterCount: 1 },
  { abbrev: "jd", name: "Judas", testament: "NT", bookOrder: 65, chapterCount: 1 },
  { abbrev: "ap", name: "Apocalipse", testament: "NT", bookOrder: 66, chapterCount: 22 },
];

export function getBookByAbbrev(abbrev: string): BibleBook | undefined {
  return BIBLE_BOOK_CATALOG.find((book) => book.abbrev === abbrev.toLowerCase());
}

/** Nome para exibição no idioma atual (a sigla/`book.name` pt seguem canônicos). */
export function getBookDisplayName(abbrev: string): string {
  return getLocalizedBookName(abbrev) ?? getBookByAbbrev(abbrev)?.name ?? abbrev;
}

export function formatBookChapterLabel(bookAbbrev: string, chapter: number): string {
  const book = getBookByAbbrev(bookAbbrev);
  if (!book) return `Cap. ${chapter}`;
  return `${getBookDisplayName(book.abbrev)} ${chapter}`;
}

export function getBooksByTestament(testament: BibleTestament): BibleBook[] {
  return BIBLE_BOOK_CATALOG.filter((book) => book.testament === testament);
}

export function getAdjacentChapter(
  bookAbbrev: string,
  chapter: number,
  direction: -1 | 1,
): { bookAbbrev: string; chapter: number } | null {
  const normalized = bookAbbrev.toLowerCase();
  const currentIndex = BIBLE_BOOK_CATALOG.findIndex((book) => book.abbrev === normalized);
  if (currentIndex < 0) {
    return null;
  }

  const currentBook = BIBLE_BOOK_CATALOG[currentIndex];

  if (direction === 1) {
    if (chapter < currentBook.chapterCount) {
      return { bookAbbrev: currentBook.abbrev, chapter: chapter + 1 };
    }
    const nextBook = BIBLE_BOOK_CATALOG[currentIndex + 1];
    return nextBook ? { bookAbbrev: nextBook.abbrev, chapter: 1 } : null;
  }

  if (chapter > 1) {
    return { bookAbbrev: currentBook.abbrev, chapter: chapter - 1 };
  }

  const previousBook = BIBLE_BOOK_CATALOG[currentIndex - 1];
  return previousBook
    ? { bookAbbrev: previousBook.abbrev, chapter: previousBook.chapterCount }
    : null;
}
